<template>
    <!-- エネルギー入力画面 -->
    <v-container>
        <v-card class='detail' flat>
            <v-row>
                <v-col cols="4" class="headerTitle">
                    <ryou-select class="bukens" :items="dynamicItems" :itemText="'building_name'" :label="'物件名'" :itemValue="'building_id'"
                                 v-model="selectBuild" :value="selectBuild">
                    </ryou-select>
                </v-col>
                <v-col cols="4" class="headerTitle">
                    <ryou-select class="bukens" :items="energyItems" :itemText="'code_text'" :label="'エネルギー選択'" :itemValue="'code_value'"
                                 v-model="selectEnergy" :value="selectEnergy">
                    </ryou-select>
                </v-col>
                <v-col cols="2" class="headerTitle">
                    <ryou-date-format ref="ryou_date_format" v-model="date" :value="date" :rules="monthRules" :label="'対象年月'" :format ="'$1/$2'">
                    </ryou-date-format>
                </v-col>
                <v-col cols="2" class="addBtn">
                    <ryou-blue-btn :label="'新規追加'" :handlerClick="handleAdd"></ryou-blue-btn>
                </v-col>
            </v-row>

            <v-form ref="tableForm" v-model="tableForm" lazy-validation>
                <ryou-table ref="ryouTable" :rowKey="rowKey" :headers="headers" :url="url" :handleEdit="handleEdit"
                            :handleDelete="handleDelete" :businessKeys="businessKeys" :queryParams="queryParam" style="margin-top: 10px;">
                </ryou-table>
            </v-form>
        </v-card>
        <salary-energy-input-dialog ref="modalForm" @ok="modalFormOk" :url="url" :selectedBuild ="selectBuild" :selectedEnergy="selectEnergy"
                                    :buildItems="dynamicItems" :energyItems="energyItems" :roomItems="roomItems"></salary-energy-input-dialog>
        <ryou-confirm ref="confirm"></ryou-confirm>
    </v-container>
</template>

<script>
    import RyouSelect from "@/components/formInput/RyouSelect.vue";
    import RyouBlueBtn from "@/components/formInput/RyouBlueBtn.vue";
    import RyouTable from "@/components/table/RyouTable.vue";
    import RyouConfirm from "@/components/dialog/RyouConfirm.vue";
    import SalaryEnergyInputDialog from "./modules/SalaryEnergyInputDialog.vue";
    import RyouDateFormat from "@/components/formInput/RyouDateFormat.vue";
    import { RyouTableMixins } from "@/mixins/RyouTableMixins";
    export default {
        name: "SalaryEnergyInput",
        mixins: [RyouTableMixins],
        components: {
            RyouSelect,
            RyouBlueBtn,
            RyouTable,
            RyouConfirm,
            SalaryEnergyInputDialog,
            RyouDateFormat
        },
        mounted() {
            this.monthRules.push(this.GlobalRules.required);
        },
        data() {
            return {
                initFlag: false,
                rowKey: "rowIndex",
                tableForm: true,
                selectBuild: "",
                selectEnergy:"",
                date: "",
                monthRules: [],
                dynamicItems: [],
                energyItems: [],
                roomItems:[],
                businessKeys: ["room_id","building_id","input_date","energyClass"],
                headers: [
                    {
                        text: "部屋番号",
                        class: "blue lighten-2 title",
                        value: "room_id",
                        align: "center",
                        width: "9%",
                        sortable: true,
                        groupable: false
                    },
                    {
                        text: "氏名",
                        class: "blue lighten-2 title",
                        value: "user_name",
                        align: "center",
                        width: "20%",
                        groupable: false
                    },
                    {
                        text: "前回メータ値",
                        class: "blue lighten-2 title",
                        value: "befor_meter_val",
                        align: "center",
                        width: "15%",
                        sortable: true,
                        groupable: false
                    },
                    {
                        text: "今回メータ値",
                        class: "blue lighten-2 title",
                        value: "now_meter_val",
                        align: "center",
                        width: "15%",
                        sortable: true,
                        groupable: false
                    },
                    {
                        text: "前回使用料",
                        class: "blue lighten-2 title",
                        value: "befor_use_amount",
                        align: "center",
                        width: "15%",
                        sortable: true,
                        groupable: false
                    },
                    {
                        text: "今回使用料",
                        class: "blue lighten-2 title",
                        value: "now_use_amount",
                        align: "center",
                        width: "15%",
                        sortable: true,
                        groupable: false,
                    },
                    {
                        text: "操作",
                        class: "blue lighten-2 title",
                        value: "actions",
                        align: "center",
                        sortable: false,
                        groupable: false
                    }
                ],
                url: {
                    list: "/energyInput/get" + "/" + null + "/" + null + "/" + null,
                    delete: "/energyInput/delete",
                    add: "/energyInput/insert",
                    update: "/energyInput/update",
                },
                height: 600,
            }
        },
        created() {
            this.initData();
        },
        watch: {
            selectBuild() {
                if (this.initFlag) {
                    this.callLoadData()
                }
            },
            selectEnergy() {
                if (this.initFlag) {
                    this.callLoadData()
                }
            },
            date() {
                if (this.initFlag) {
                    this.callLoadData()
                }
            },
        },
        methods: {
            initData(callLoadData) {//eslint-disable-line
                let params = {
                    userId: this.$store.getters.getUserId,
                    userClass: this.$store.getters.getUserClass,
                }
                this.getRequest("/energyInput/buildingNameGet", params, this.$store.getters.getUserToken).then(data => {  //物件名取得
                    if (data.success) {
                        this.dynamicItems = data.result;      
                        this.selectBuild = this.dynamicItems[0].building_id;
                        //console.log(this.selectBuild)
                    }  
                });
                this.getRequest("/energyInput/energyClassGet", null, this.$store.getters.getUserToken).then(data => {           //エネルギー区分取得
                    if (data.success) {
                        this.energyItems = data.result;
                        this.selectEnergy = this.energyItems[0].code_value;
                        this.initFlag = true;
                    }
                })
                const tmpdate = new Date()
                const month = ("0" + (tmpdate.getMonth() + 1)).slice(-2)
                this.date = tmpdate.getFullYear() + "-" + month
                

                this.getRequest("/energyInput/existRoomGet", null, this.$store.getters.getUserToken).then(data => {  //存在する部屋取得
                    if (data.success) {
                        this.roomItems = data.result;
                    }
                });

            },
      
            callLoadData() {
                if (this.selectBuild != "" && this.selectEnergy != "" && this.date !="") {
                    this.url.list = "/energyInput/get" + "/" + this.selectBuild + "/" + this.selectEnergy + "/" + this.date
                    this.$refs.ryou_date_format.initViewDate(this.date);
                    this.$refs.ryouTable.loadData();
                }

            }

        }
    };
</script>

<style scoped>
    .detail {
        padding-top: 20px;
    }

    .headerTitle {
        padding-bottom: 0px;
    }

    .headerbtn {
        padding: 0px 12px;
        margin-bottom: 30px;
    }

    .buken {
        width: 150px;
        height: 60px;
        padding-top: 2%;
    }

    .bukens {
        width: 300px;
        height: 80px;
    }

    .buken,
    .bukens {
        float: left;
        box-sizing: border-box;
    }
</style>